import React from "react";
import { FaTwitter, FaInstagram, FaGithub, FaLinkedinIn } from "react-icons/fa"



export default function Footer(){
    return(
        <div className="footer-section">
        <div className="footer-email">
            <h3 className="footer-title">Email:</h3>
            <a href = "mailto: musembisteven@gmail.com">info@stevo.dev </a>
        </div>
        <div className="footer-socials">
            <h3 className="footer-title">follow:</h3>
            <ul className="footer-icons">
            <li><a href="https://github.com/stevomusembi" target="_blank"><FaGithub /></a></li>
            <li><a href="https://www.linkedin.com/in/stevenmusembi" target="_blank"> <FaLinkedinIn /></a></li>
            <li><a href="https://twitter.com/voshtty" target="_blank"> <FaTwitter /></a></li>
            <li><a href="https://www.instagram.com/steven_musembi/" target="_blank"> <FaInstagram /></a></li>
            </ul>
        </div>

        </div>
    )
}